import { render, staticRenderFns } from "./audit-dialog.vue?vue&type=template&id=227874fc&scoped=true&"
import script from "./audit-dialog.vue?vue&type=script&lang=js&"
export * from "./audit-dialog.vue?vue&type=script&lang=js&"
import style0 from "./audit-dialog.vue?vue&type=style&index=0&id=227874fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227874fc",
  null
  
)

export default component.exports